<template>
  <div>
    <div class="header-image pb-5">
      <div
        v-if="isBusinessAdmin"
        class="w-100 text-center white--text font-weight-bold header-text py-4"
      >
        Welcome<span v-if="user">, {{ user.full_name }}</span
        >. Quickly search, download or share company files.
      </div>

      <div
        v-if="isTradie"
        class="w-100 text-center white--text font-weight-bold header-text py-4"
      >
        Welcome<span v-if="user">, {{ user.full_name }}</span
        >. Quickly search, download or share files.
      </div>

      <search-bar @searchedFile="fileSearch" />
    </div>

    <!-- <div fluid-grow alt="banner" class="header-image rounded-0"></div> -->

    <b-container v-show="!searchedFile" class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <h4 class="font-weight-bold">Files</h4>
            </b-row>
            <b-row
              v-if="hasFileToolbarActions"
              class="file-menu-container px-3"
            >
              <b-col
                cols="12"
                :md="bulkHasSelection && canBulkActOnFiles ? 6 : 12"
                :lg="bulkHasSelection && canBulkActOnFiles ? 6 : 12"
                class="mb-0 d-flex align-items-end flex-wrap"
              >
                <b-button
                  v-if="canBulkActOnFiles"
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="toggleSelectAllFiles"
                >
                  <span class="tab__label">
                    <b-icon
                      icon="check"
                      :style="{
                        visibility: bulkHasSelection ? 'visible' : 'hidden',
                      }"
                    ></b-icon>
                    Select All
                    <!-- Mirrors the checkmark's reserved width on the other
                    side so "Select All" itself sits centered under the
                    active-tab underline, instead of the whole (icon + text)
                    label being centered and shifting the visible text right. -->
                    <b-icon
                      icon="check"
                      style="visibility: hidden"
                      aria-hidden="true"
                    ></b-icon>
                  </span>
                  <div class="active-tab mt-2 mx-auto"></div>
                </b-button>

                <b-button
                  v-if="canCreateCompanyFile"
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="createNewFile"
                >
                  <span class="tab__label">
                    <b-icon-plus class="align-middle"> </b-icon-plus>
                    New Company File
                  </span>
                  <div class="active-tab mt-2 mx-auto"></div>
                </b-button>
                <b-button
                  v-if="isTradie"
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="createNewFile"
                >
                  <span class="tab__label">
                    <b-icon-plus class="align-middle"> </b-icon-plus>
                    New File
                  </span>
                  <div class="active-tab mt-2 mx-auto"></div>
                </b-button>
              </b-col>
              <b-col
                v-if="bulkHasSelection && canBulkActOnFiles"
                cols="12"
                class="selection-col d-flex d-md-none align-items-center justify-content-between py-2"
              >
                <span class="selected-label">
                  {{ bulkSelectedCount }} selected
                </span>
                <div class="d-flex align-items-center mobile-actions">
                  <b-button
                    v-if="canDownloadFile"
                    variant="link"
                    class="mobile-action-link"
                    :disabled="loading"
                    @click="bulkDownload"
                  >
                    Download
                  </b-button>
                  <b-button
                    v-if="canShareFile"
                    variant="link"
                    class="mobile-action-link"
                    :disabled="loading"
                    @click="shareFiles"
                  >
                    Share
                  </b-button>
                  <b-button
                    variant="link"
                    class="mobile-action-link mobile-action-clear"
                    :disabled="loading"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </div>
              </b-col>
              <div
                v-if="bulkHasSelection && canBulkActOnFiles"
                class="d-none d-md-flex desktop-selection-actions"
              >
                <b-button-group
                  variant="outlined"
                  class="font-weight-bold gray--2"
                  :disabled="loading"
                >
                  <b-dropdown
                    :text="`Selected ${bulkSelectedCount} item/s`"
                    variant="outlined"
                    class="gray--2"
                  >
                    <b-dropdown-item
                      v-if="canDownloadFile"
                      @click="bulkDownload"
                    >
                      <b-icon
                        icon="download"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Download Selected Item/s
                    </b-dropdown-item>
                    <b-dropdown-item v-if="canShareFile" @click="shareFiles">
                      <b-icon
                        icon="cursor"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Share Selected File/s
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-button
                    right
                    variant="outlined"
                    class="gray--2"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </b-button-group>
              </div>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="files"
              :selected-files="checkedFiles"
              :selectable="canBulkActOnFiles"
              ref="fileList"
              @selectedFiles="filesSelected"
              @shareSingleFile="shareFiles"
              @reloadFileList="getFileList"
            />
            <b-pagination
              v-if="filesMeta.total > filesMeta.per_page"
              v-model="currentPage"
              :total-rows="filesMeta.total"
              :per-page="filesMeta.per_page"
              class="px-3 pt-4"
              align="center"
              size="sm"
            ></b-pagination>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-show="searchedFile" class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row class="mb-3">
              <b-col cols="12">
                <h4 class="font-weight-bold mb-0">All Search Results</h4>
              </b-col>
            </b-row>
            <b-row
              v-if="hasFileToolbarActions"
              class="file-menu-container px-3"
            >
              <b-col
                cols="12"
                :md="bulkHasSelection && canBulkActOnFiles ? 6 : 12"
                :lg="bulkHasSelection && canBulkActOnFiles ? 6 : 12"
                class="mb-0 d-flex align-items-end flex-wrap"
              >
                <b-button
                  v-if="canBulkActOnFiles"
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="toggleSelectAllFiles"
                >
                  <span class="tab__label">
                    <b-icon
                      icon="check"
                      :style="{
                        visibility: bulkHasSelection ? 'visible' : 'hidden',
                      }"
                    ></b-icon>
                    Select All
                    <!-- Mirrors the checkmark's reserved width on the other
                    side so "Select All" itself sits centered under the
                    active-tab underline, instead of the whole (icon + text)
                    label being centered and shifting the visible text right. -->
                    <b-icon
                      icon="check"
                      style="visibility: hidden"
                      aria-hidden="true"
                    ></b-icon>
                  </span>
                  <div class="active-tab mt-2 mx-auto"></div>
                </b-button>

                <b-button
                  v-if="canCreateCompanyFile"
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="createNewFile"
                >
                  <span class="tab__label">
                    <b-icon-plus class="align-middle"> </b-icon-plus>
                    New Company File
                  </span>
                  <div class="active-tab mt-2 mx-auto"></div>
                </b-button>
                <b-button
                  v-if="isTradie"
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="createNewFile"
                >
                  <span class="tab__label">
                    <b-icon-plus class="align-middle"> </b-icon-plus>
                    New File
                  </span>
                  <div class="active-tab mt-2 mx-auto"></div>
                </b-button>
              </b-col>
              <b-col
                v-if="bulkHasSelection && canBulkActOnFiles"
                cols="12"
                class="selection-col d-flex d-md-none align-items-center justify-content-between py-2"
              >
                <span class="selected-label">
                  {{ bulkSelectedCount }} selected
                </span>
                <div class="d-flex align-items-center mobile-actions">
                  <b-button
                    v-if="canDownloadFile"
                    variant="link"
                    class="mobile-action-link"
                    :disabled="loading || searchSelectAllResolving"
                    @click="bulkDownload"
                  >
                    Download
                  </b-button>
                  <b-button
                    v-if="canShareFile"
                    variant="link"
                    class="mobile-action-link"
                    :disabled="loading || searchSelectAllResolving"
                    @click="shareFiles"
                  >
                    Share
                  </b-button>
                  <b-button
                    variant="link"
                    class="mobile-action-link mobile-action-clear"
                    :disabled="loading || searchSelectAllResolving"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </div>
              </b-col>
              <div
                v-if="bulkHasSelection && canBulkActOnFiles"
                class="d-none d-md-flex desktop-selection-actions"
              >
                <b-button-group
                  variant="outlined"
                  class="font-weight-bold gray--2"
                  :disabled="loading || searchSelectAllResolving"
                >
                  <b-dropdown
                    :text="`Selected ${bulkSelectedCount} item/s`"
                    variant="outlined"
                    class="gray--2"
                  >
                    <b-dropdown-item
                      v-if="canDownloadFile"
                      @click="bulkDownload"
                    >
                      <b-icon
                        icon="download"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Download Selected Item/s
                    </b-dropdown-item>
                    <b-dropdown-item v-if="canShareFile" @click="shareFiles">
                      <b-icon
                        icon="cursor"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Share Selected File/s
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-button
                    right
                    variant="outlined"
                    class="gray--2"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </b-button-group>
              </div>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="files"
              :selectable="canBulkActOnFiles"
              ref="searchedFileList"
              @selectedFiles="filesSelected"
              @shareSingleFile="shareFiles"
            />
            <b-pagination
              v-if="filesMeta.total > searchPerPage"
              v-model="searchCurrentPage"
              :total-rows="filesMeta.total"
              :per-page="searchPerPage"
              class="px-3 pt-4"
              align="center"
              size="sm"
            ></b-pagination>
          </b-card>
          <p v-if="searchedFile && !files.length" class="px-2">
            No File/s found.
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- Shared With Me / Shared By Me stay visible (and filtered by the
         search bar via searchedFile) whether or not you're searching, unlike
         "Files" above which swaps to the dedicated All Search Results view.
         They sit after both file containers so the section order stays
         Files/Results first, shared lists below, searching or not. -->
    <b-container class="custom-container mt-5">
      <b-row v-if="isBusinessAdmin || isTradie">
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <h4 class="font-weight-bold">Shared With Me</h4>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="sharedFiles"
              :selectable="false"
              :shared-view="true"
              :can-reshare="true"
              ref="sharedFileList"
              @shareSingleFile="shareReceivedFile"
              @reloadFileList="getSharedFileList"
            />
            <b-pagination
              v-if="sharedFilesMeta.total > sharedFilesMeta.per_page"
              v-model="sharedCurrentPage"
              :total-rows="sharedFilesMeta.total"
              :per-page="sharedFilesMeta.per_page"
              class="px-3 pt-4"
              align="center"
              size="sm"
            ></b-pagination>
          </b-card>
          <p v-if="searchedFile && !sharedFiles.length" class="px-2">
            No File/s found.
          </p>
        </b-col>
      </b-row>

      <b-row v-if="isBusinessAdmin || isTradie">
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <h4 class="font-weight-bold">Shared By Me</h4>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="sentFiles"
              :selectable="false"
              ref="sentFileList"
              @shareSingleFile="shareSentFile"
              @reloadFileList="reloadSentFileList"
            />
            <b-pagination
              v-if="sentFilesMeta.total > sentFilesMeta.per_page"
              v-model="sentCurrentPage"
              :total-rows="sentFilesMeta.total"
              :per-page="sentFilesMeta.per_page"
              class="px-3 pt-4"
              align="center"
              size="sm"
            ></b-pagination>
          </b-card>
          <p v-if="searchedFile && !sentFiles.length" class="px-2">
            No File/s found.
          </p>
        </b-col>
      </b-row>
    </b-container>
    <subscription-modal v-model="show" @close="show = false" />
    <share-file-modal
      :showShareFiles="showShareFiles"
      :selectedFiles="checkedFiles"
      :fileShares="fileShares"
      :isReshare="shareModalSource === 'received'"
      @closeShareFileModal="showShareFiles = false"
      @fileShareResponsePrompt="shareFileResponsePrompt"
      @reloadFileList="reloadShareModalList"
    />

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      :class="{
        'bg-danger border-danger': alertType === 'danger',
      }"
      dismissible
      fade
      :variant="alertType"
      @dismiss-count-down="countDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import File from '@/models/File'
import SearchBar from '@/components/SearchBar'
import FileList from '@/components/lists/FileList'
import SubscriptionModal from '@/components/modals/SubscriptionModal'
import ShareFileModal from '@/components/modals/ShareFileModal'

export default {
  components: {
    SearchBar,
    FileList,
    SubscriptionModal,
    ShareFileModal,
  },

  data() {
    return {
      loading: false,
      sharedFilesLoading: false,
      sentFilesLoading: false,
      checkedFiles: [],
      searchedFile: '',
      show:
        this.$route.params.show === undefined ? false : this.$route.params.show,
      showShareFiles: false,
      /** Which list opened the share modal, so revoking/sharing refreshes the right one. */
      shareModalSource: 'files',
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
      currentPage: 1,
      sharedCurrentPage: 1,
      sentCurrentPage: 1,
      searchCurrentPage: 1,
      suppressSearchPageWatch: false,
      /** Search "select all" is fetching remaining pages (UI shows full count; actions stay disabled). */
      searchSelectAllResolving: false,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    ...mapGetters('file', [
      'files',
      'filesMeta',
      'sharedFiles',
      'sharedFilesMeta',
      'sentFiles',
      'sentFilesMeta',
    ]),
    ...mapGetters('auth', ['hasPermission']),

    isTradie() {
      return this.user ? this.user.user_type === 'tradie' : false
    },

    isBusinessAdmin() {
      return this.user ? this.user.user_type === 'business_admin' : false
    },

    /** Company-file creation requires the files.upload permission for BAs. */
    canCreateCompanyFile() {
      return this.isBusinessAdmin && this.hasPermission('files.upload')
    },

    canDownloadFile() {
      return !this.isBusinessAdmin || this.hasPermission('files.download')
    },

    canShareFile() {
      return !this.isBusinessAdmin || this.hasPermission('files.share')
    },

    /**
     * Selecting files is only useful when there's a bulk action to run on them.
     * A BA with view-only access can neither download nor share, so the
     * Select All button, per-card checkboxes and selection menu are hidden.
     */
    canBulkActOnFiles() {
      return this.canDownloadFile || this.canShareFile
    },

    /**
     * Whether the toolbar has any button to show. When false (e.g. a view-only
     * BA) the toolbar bar is hidden entirely so it isn't an empty box.
     */
    hasFileToolbarActions() {
      return (
        this.canBulkActOnFiles || this.canCreateCompanyFile || this.isTradie
      )
    },

    searchPerPage() {
      const p = this.filesMeta && this.filesMeta.per_page
      return typeof p === 'number' && p > 0 ? p : 10
    },

    bulkSelectedCount() {
      if (this.searchedFile && this.searchSelectAllResolving) {
        const t = this.filesMeta && this.filesMeta.total
        return typeof t === 'number' ? t : this.checkedFiles.length
      }
      return this.checkedFiles.length
    },

    bulkHasSelection() {
      return this.checkedFiles.length > 0 || this.searchSelectAllResolving
    },
  },

  methods: {
    ...mapActions({
      getFiles: 'file/getFiles',
      getSearchedFiles: 'file/getSearchedFiles',
      getSharedFiles: 'file/getSharedFiles',
      getSentFiles: 'file/getSentFiles',
    }),
    async getFileList(page = 1) {
      this.loading = true
      // this.clearSelectedFiles()
      try {
        await this.getFiles(page)
      } catch (e) {
        this.$bvToast.toast('Could not load files. Please try again.', {
          variant: 'danger',
          title: 'Error',
        })
      } finally {
        this.loading = false
      }
    },

    async getSharedFileList(page = 1) {
      this.sharedFilesLoading = true
      await this.getSharedFiles({ page, search: this.searchedFile })
      this.sharedFilesLoading = false
    },

    async getSentFileList(page = 1) {
      this.sentFilesLoading = true
      await this.getSentFiles({ page, search: this.searchedFile })
      this.sentFilesLoading = false
    },

    // "Cancel Share" on a Shared By Me card hits share-revoke directly
    // (bypassing the Share modal), so the Files tab's own copy of that
    // file's file_shares is never told about it — refresh both here or
    // reopening Share from the Files tab still shows the cancelled email.
    reloadSentFileList(page = 1) {
      this.getSentFileList(page)
      this.getFileList(this.currentPage)
    },

    async selectAllFiles() {
      const response = await this.$api.get('file-ids')
      const ids = response.data && response.data.data
      this.checkedFiles = Array.isArray(ids) ? ids : []
    },

    idsFromSearchPageResponse(res) {
      const pageFiles = Array.isArray(res)
        ? res
        : res && res.data
        ? res.data
        : []
      const ids = []
      pageFiles.forEach((f) => {
        if (f && f.id != null) {
          ids.push(f.id)
        }
      })
      return ids
    },

    /**
     * Load every file id matching the current search (all pages, parallel requests).
     */
    async selectAllSearchResults() {
      const total = (this.filesMeta && this.filesMeta.total) || 0
      if (!total || !this.searchedFile) {
        return []
      }
      const perPage = this.searchPerPage
      const lastPage =
        (this.filesMeta && this.filesMeta.last_page) ||
        Math.max(1, Math.ceil(total / perPage))
      const searchTerm = this.searchedFile

      const tasks = []
      for (let p = 1; p <= lastPage; p++) {
        const model = new File()
        tasks.push(
          model.page(p).limit(perPage).where('search', searchTerm).get(),
        )
      }
      const results = await Promise.all(tasks)
      const ids = []
      results.forEach((res) => {
        ids.push(...this.idsFromSearchPageResponse(res))
      })
      return [...new Set(ids)]
    },

    unselectAllFiles() {
      this.clearSelectedFiles()
    },

    toggleSelectAllFiles() {
      const listRef = this.searchedFile
        ? this.$refs.searchedFileList
        : this.$refs.fileList

      if (this.searchedFile) {
        if (this.searchSelectAllResolving) {
          return
        }
        const total = (this.filesMeta && this.filesMeta.total) || 0
        const allSearchSelected =
          total > 0 && this.checkedFiles.length === total
        if (allSearchSelected) {
          this.unselectAllFiles()
        } else {
          this.searchSelectAllResolving = true
          if (listRef) {
            listRef.selectAllFiles()
          }
          this.selectAllSearchResults()
            .then((ids) => {
              this.checkedFiles = ids
              const list = this.$refs.searchedFileList
              if (list) {
                list.syncSelectedIds(ids)
              }
            })
            .catch(() => {
              this.clearSelectedFiles()
              this.$emit(
                'showAlert',
                'Could not load all files for this search. Try again.',
              )
            })
            .finally(() => {
              this.searchSelectAllResolving = false
            })
        }
      } else if (
        this.filesMeta.total > 0 &&
        this.checkedFiles.length === this.filesMeta.total
      ) {
        this.unselectAllFiles()
      } else {
        this.selectAllFiles()
        if (listRef) listRef.selectAllFiles()
      }
    },

    filesSelected(filesFromChild) {
      if (this.searchedFile) {
        if (this.files && this.files.length) {
          const pageIds = new Set(this.files.map((f) => f.id))
          const kept = this.checkedFiles.filter((id) => !pageIds.has(id))
          this.checkedFiles = [...kept, ...filesFromChild]
        } else {
          this.checkedFiles = filesFromChild
        }
      } else {
        this.checkedFiles = filesFromChild
      }
    },
    clearSelectedFiles() {
      this.checkedFiles = []
      this.searchSelectAllResolving = false
      if (this.$refs.fileList) {
        this.$refs.fileList.clearFilesSelected()
      }
      if (this.$refs.searchedFileList) {
        this.$refs.searchedFileList.clearFilesSelected()
      }
    },
    async bulkDownload() {
      if (!this.canDownloadFile) return

      await this.$api
        .get('download-bulk-files', {
          responseType: 'blob',
          params: { files: this.checkedFiles },
        })
        .then((data) => {
          const name = this.user.full_name
          const filename = `${name}.zip`
          const url = URL.createObjectURL(
            new Blob([data.data], {
              type: 'application/zip',
            }),
          )
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch((e) => {
          setTimeout((e) => {
            this.$emit('showAlert', 'downloaded unsuccessfully.')
          }, 5000)
        })
    },
    async fetchSearchResults(page) {
      this.loading = true
      try {
        await this.getSearchedFiles({
          search: this.searchedFile,
          page: page,
          limit: this.searchPerPage,
        })
        this.$nextTick(() => {
          const list = this.$refs.searchedFileList
          if (list && this.checkedFiles.length) {
            list.syncSelectedIds(this.checkedFiles)
          }
        })
      } catch (error) {
        this.$emit('showAlert', 'error while searching for file/s: ', error)
      } finally {
        this.loading = false
      }
    },

    async fileSearch(name) {
      this.searchedFile = name
      this.clearSelectedFiles()

      if (!this.searchedFile) {
        this.searchCurrentPage = 1
        await this.getFileList()
      } else {
        this.suppressSearchPageWatch = true
        this.searchCurrentPage = 1
        try {
          await this.fetchSearchResults(1)
        } finally {
          this.suppressSearchPageWatch = false
        }
      }

      // Shared With Me / Shared By Me stay visible (and filtered) regardless
      // of whether there's a search term, so re-fetch page 1 either way.
      this.sharedCurrentPage = 1
      this.sentCurrentPage = 1
      await Promise.all([this.getSharedFileList(1), this.getSentFileList(1)])
    },
    shareFiles() {
      if (!this.canShareFile) return

      const firstFile = this.files.find(
        (file) => file.id === this.checkedFiles[0],
      )
      this.fileShares = firstFile ? firstFile.file_shares : []
      this.shareModalSource = 'files'

      this.showShareFiles = true
    },
    /** Opening the Share modal from a "Shared By Me" card — items there are
     * FileShareResource-shaped (the real file is nested under `.file`). */
    shareSentFile(item) {
      const file = item && item.file ? item.file : item
      if (!file) return

      this.checkedFiles = [file.id]
      this.fileShares = file.file_shares || []
      this.shareModalSource = 'sent'

      this.showShareFiles = true
    },
    /** Opening the Share modal from a "Shared With Me" card, to reshare it onward. */
    shareReceivedFile(item) {
      const file = item && item.file ? item.file : item
      if (!file) return

      this.checkedFiles = [file.id]
      this.fileShares = file.file_shares || []
      this.shareModalSource = 'received'

      this.showShareFiles = true
    },
    reloadShareModalList() {
      if (this.shareModalSource === 'sent') {
        this.getSentFileList(this.sentCurrentPage)
      } else if (this.shareModalSource === 'received') {
        // Resharing a file from "Shared With Me" also creates a new "Shared
        // By Me" entry, so that tab needs refreshing too, not just Shared With Me.
        this.getSharedFileList(this.sharedCurrentPage)
        this.getSentFileList(this.sentCurrentPage)
      } else {
        this.getFileList(this.currentPage)
      }
    },
    async shareFileResponsePrompt(res) {
      if (res.success) {
        await this.reloadShareModalList()

        this.alertMsg = 'File shared successfully'
        this.dismissCountDown = 15

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402 || res.status === 422) {
          if (res.message) {
            this.alertMsg = res.message
          } else {
            this.alertMsg = 'File shared unsuccessful!'
          }
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
    },
    showAlert() {
      this.dismissCountDown = 5
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },
    createNewFile() {
      // Guard the action too — BAs without files.upload can't create company files.
      if (this.isBusinessAdmin && !this.hasPermission('files.upload')) {
        return
      }
      this.$router.push({ name: 'templates.list-page' })
    },
  },
  mounted() {
    this.getFileList()
    if (this.isBusinessAdmin || this.isTradie) {
      this.getSharedFileList()
      this.getSentFileList()
    }
  },
  watch: {
    searchedFile(newVal) {
      if (!newVal) {
        this.searchCurrentPage = 1
        this.getFileList()
      }
    },
    searchCurrentPage(page) {
      if (!this.searchedFile) {
        return
      }
      if (this.suppressSearchPageWatch) {
        this.suppressSearchPageWatch = false
        return
      }
      this.fetchSearchResults(page)
    },
    currentPage(value) {
      if (this.searchedFile) {
        return
      }
      this.getFileList(value)
    },
    sharedCurrentPage(value) {
      this.getSharedFileList(value)
    },
    sentCurrentPage(value) {
      this.getSentFileList(value)
    },
  },
}
</script>

<style lang="scss" scoped>
.header-image {
  // top: 88px;
  // height: 280px;
  background: transparent linear-gradient(130deg, #006cff 0%, #00429d 100%) 0%
    0% no-repeat padding-box;
}

.header-text {
  // top: 136px;
  margin-top: 88px;
  font-size: 35px;

  @media (max-width: 575px) {
    margin-top: 70px;
    font-size: 20px;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

/deep/ nav.center-screen {
  margin-top: 0;
}

.file-menu-container {
  background: white;
  border: 1px solid #b6c3d94d;
  border-radius: 8px;
  position: relative;

  // On small screens the row's own px-3 plus the column's default Bootstrap
  // gutter padding stack up, pushing the tab buttons noticeably further right
  // than the "Files" heading above. Trim both so the buttons line up with it
  // and sit comfortably within the card instead of looking off-centre.
  @media (max-width: 767.98px) {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;

    > .col,
    > [class*='col-'] {
      padding-left: 0.25rem;
      padding-right: 0.25rem;
    }
  }
}

.desktop-selection-actions {
  position: absolute;
  right: 1rem;
  top: 0;
  bottom: 0;
  align-items: center;
}

.tab {
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  vertical-align: bottom;

  &__label {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    white-space: nowrap;
  }

  @media (max-width: 575px) {
    width: 100%;
    height: auto !important;
    align-items: flex-start;
    padding: 0.6rem 0.75rem !important;
    font-size: 0.85rem;
    border-bottom: 1px solid #b6c3d94d;

    &:last-child {
      border-bottom: none;
    }

    .active-tab,
    .no-active-tab {
      display: none;
    }
  }

  @media (min-width: 576px) and (max-width: 767px) {
    height: auto !important;
    padding-top: 0.6rem !important;
    padding-bottom: 0.6rem !important;
    font-size: 0.8rem;

    .active-tab {
      height: 6px;
      width: 80px;
    }
  }

  &:hover,
  &:focus,
  &:active {
    background-color: #eaf3ff !important;
    color: #006cff !important;
  }
}

.selection-col {
  @media (max-width: 767px) {
    border-top: 1px solid #b6c3d94d;
    // The global .col-12 rule adds a 30px bottom margin, which reads as
    // random dead space inside the white toolbar card — drop it here.
    margin-bottom: 0;
  }
}

.selected-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #364052;
}

.mobile-actions {
  gap: 0;
}

.mobile-action-link {
  font-size: 0.8rem;
  font-weight: 600;
  color: #006cff !important;
  padding: 0 0.5rem;
  text-decoration: none !important;
  line-height: 1;
  position: relative;
  // The global .btn rule fixes buttons at 56px tall, which inflates the
  // "x selected" row with empty space above and below these text links.
  height: auto;

  & + .mobile-action-link::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 0.9rem;
    width: 1px;
    background-color: #b6c3d9;
  }

  &:hover {
    opacity: 0.75;
  }
}

.mobile-action-clear {
  color: #364052 !important;
}
</style>
